import os from '@utils/os'
import utils from '@utils'
import saasRequest from '@request/saasRequest'
import Request from '@request'
import host from '@request/host'

import api from '@api'
import { NativeMessageData, NativeMessagePush } from '@utils/nativeBridge/nativeMessage'
export default class NativeBridge {
  static actionSupportMap = {
    share: 'share',
    pushNative: 'pushNative',
    pushWeb: 'pushWeb',
    notice: 'notice',
    getData: 'getData',
    pay: 'pay',
    getStorage: 'getStorage',
    resourceCache: 'resourceCache'
  }

  constructor({ store, router, vm }) {
    this.os = 'unknow'
    if (os.isAndroid()) {
      this.os = 'android'
    } else if (os.isIOS()) {
      this.os = 'ios'
    } else if (os.getDevice() === 'mac') {
      this.os = 'mac'
    }

    this.vm = vm
    this.callbackCache = undefined
  }

  isSupportAction(actionName) {
    return !!NativeBridge.actionSupportMap[actionName]
  }

  sendMessage(message) {
    if (!(this.vm.$store.getters.isInApp || this.os === 'mac') || !message.actionName) return
    if (!message.extend) console.error('数据对象不正确')
    if (!this.isSupportAction(message.actionName)) console.error('不支持的action')
    if (message.actionName === 'pushNative') {
      const { params = {}, pageName } = message.params.data
      if (!pageName || (pageName === 'newWeb' && !params.url)) return
    }
    try {
      if (message.actionName == 'pushNative') {
        message.extend({
          userInfo: {
            ...this.vm.$store.getters.userInfo,
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            refresh_token: localStorage.getItem('refresh_token'),
            sys_token: localStorage.getItem('sys_token')
          }
        })
      }
      if (message.callback) {
        this.callbackCache = message.callback
        delete message['callback']
      }
      let jsonStr = JSON.stringify(message)
      // if (os.isPC()) {
      //     console.log('PC阻止发送消息', message)
      //     return
      // }
      if (this.os === 'ios' || this.os === 'mac') {
        if (message.actionName === 'getData') return window.prompt(jsonStr)
        return window.webkit.messageHandlers.js2native.postMessage(jsonStr)
      } else if (this.os === 'android') {
        return window.android.js2native(jsonStr)
      } else {
        console.error('发送原生消息失败', message)
      }
    } catch (e) {
      console.log('函数内错误', e)
    }
  }

  handleMessage(message) {
    if (!(this.vm.$store.getters.isInApp || this.os === 'mac')) return
    try {
      const { actionName } = message
      if (!this.isSupportAction(actionName)) console.error('不支持的action')
      else {
        const { type, params } = message.params
        if (actionName === 'pushWeb') {
          if (!type) {
            location.replace(
              location.origin +
                '/' +
                Object.keys(params).reduce((query, key, index) => {
                  query += `${index > 0 ? '&' : '?'}${key}=${params[key]}`
                  return query
                }, '')
            )
            // this.vm.$router.replace({
            //     path: '/',
            //     query: params
            // })
            return
          }

          // 特殊处理
          if (type === 'shareDeployRegister' && !params.id) {
            params['id'] = 'eyJpZCI6IjM1In0='
          }
          if (type === 'statusVerification') {
            this.vm.$store.commit('setverticallHung', true)
          }
          this.vm.$router.push({
            path: `/${type}`,
            query: params
          })
        } else if (actionName === 'notice') {
          if (type === 'appState') {
            console.log(params.state, '是不是后台运行')
            // 把状态存储到store供全局使用
            let isResume = params.state == 'becomeActive'
            this.vm.$store.commit('setAppResume', isResume)
            if (params.state === 'becomeActive') {
              if (
                this.vm.$router.currentRoute.matched[0].instances.default.appRunninginTheBackground
              )
                this.vm.$router.currentRoute.matched[0].instances.default.appRunninginTheBackground()
              if (this.vm.$store.getters.isLogin) {
                this.vm.$store.dispatch('user/getLoginStatus').catch(status => {
                  if (status == 401) {
                    this.vm.$store.dispatch('user/logout')
                    // vant.Dialog({
                    //     message: '您当前账号已在其它地方登录，是否重新登录？',
                    //     showConfirmButton: true,
                    //     showCancelButton: true,
                    //     className: 'shofOffLogin',
                    //     confirmButtonText: '切换帐号',
                    //     confirmButtonColor: '#0089FF',
                    //     cancelButtonText: '我知道了',
                    //     cancelButtonColor: '#888888',
                    //     overlayStyle: {
                    //         zIndex: 9999
                    //     },
                    //     getContainer: 'body',
                    // }).then(() => {
                    //     this.vm.$router.push('/login')
                    //     this.vm.$store.dispatch('user/logout')
                    // })
                    //     .catch(() => {
                    //         location.reload()
                    //     })
                  }
                })
              }
            }
          } else if (type === 'payCallback') {
            this.callbackCache && this.callbackCache()
          } else if (type === 'getStorage') {
            return localStorage.getItem(params.key)
          } else if (type == 'parseUniversalLinks') {
            // 获取入会链接通知原生
            console.log(params, 'parseUniversalLinks 获取的链接')
            let param = {}
            if (/release-m/.test(params) || /m.docbook.com.cn/.test(params)) {
              if (utils.getUrlParam(params, 'token')) {
                Request.post(api.common.startmeeting, {
                  code: decodeURIComponent(utils.getUrlParam(params, 'token'))
                }).then(res => {
                  console.log(utils.getUrlParam(params, 'token'), res.data, '------接口请求之后')
                  const { id } = res.data
                  this.vm.$nativeBridge.sendMessage(
                    new NativeMessagePush({
                      pageName: 'joinMeeting',
                      params: {
                        zoomMeetingId: id,
                        autolink: ''
                      }
                    })
                  )
                })
              } else if (utils.getUrlParam(params, 'order_id')) {
                Request.post(
                  `https://${host.env}meeting.docbook.com.cn/api/consultation/invite/joinmeeting`,
                  {
                    order_id: utils.getUrlParam(params, 'order_id')
                  }
                ).then(res => {
                  const { meetingID } = res.data
                  this.vm.$nativeBridge.sendMessage(
                    new NativeMessagePush({
                      pageName: 'joinMeeting',
                      params: {
                        zoomMeetingId: meetingID
                      }
                    })
                  )
                })
              } else {
                if (utils.getUrlParam(params, 'id')) {
                  param.zoomMeetingId = utils.getUrlParam(params, 'id')
                }
                if (utils.getUrlParam(params, 'uname')) {
                  param.uname = encodeURIComponent(utils.getUrlParam(params, 'uname'))
                }
                this.vm.$nativeBridge.sendMessage(
                  new NativeMessagePush({
                    pageName: 'joinMeeting',
                    params: param
                  })
                )
              }
            } else {
              if (utils.getUrlParam(params, 'meeting_id')) {
                param.zoomMeetingId = encodeURIComponent(utils.getUrlParam(params, 'meeting_id'))
              }
              saasRequest
                .post('/v1/meeting/urlStartMeeting', {
                  code: utils.getUrlParam(params, 'code')
                })
                .then(res => {
                  if (utils.getUrlParam(res.data.join_url, 'sid')) {
                    param.sid = encodeURIComponent(utils.getUrlParam(res.data.join_url, 'sid'))
                  }
                  if (utils.getUrlParam(res.data.join_url, 'token')) {
                    param.token = encodeURIComponent(utils.getUrlParam(res.data.join_url, 'token'))
                  }
                  console.log(params, param, '------获取的链接------')
                  this.vm.$nativeBridge.sendMessage(
                    new NativeMessagePush({
                      pageName: 'joinMeeting',
                      params: param
                    })
                  )
                })
            }
          } else if (type === 'notification') {
            console.log(params, JSON.parse(params.url), '5分钟消息推送')
            const { type, multiPartyConsultationId } = JSON.parse(params.url)
            // 1 点击 0 未点击
            const { isClickNotice } = params
            if (type == 'consultationRemind') {
              console.log(type, '5分钟消息推送')

              this.vm.$store.commit('setVideoDialogData', {
                isFive: true,
                isInvite: false,
                multiPartyConsultationId: multiPartyConsultationId
              })
              console.log({
                isFive: true,
                isInvite: false,
                multiPartyConsultationId: multiPartyConsultationId
              })
              this.vm.$store.commit('setIsVideoDialog', true)
            } else if (type == 'createMeetingRemindMultiPartyConsulations') {
              // 视频消息提醒 不跳页面
            } else {
              // 远程订单待处理页面、状态变更都跳转页面
              if (
                localStorage.getItem('userID') &&
                localStorage.getItem('token') &&
                this.vm.$store.state.user.userInfos.doctorID &&
                this.vm.$store.state.user.userInfos.hospitalID
              ) {
                let url =
                  host.authDomain +
                  '?type=default&userID=' +
                  localStorage.getItem('userID') +
                  '&token=' +
                  localStorage.getItem('token') +
                  '&env=' +
                  host.authEnv +
                  '&doctorID=' +
                  this.vm.$store.state.user.userInfos.doctorID +
                  '&hospitalId=' +
                  this.vm.$store.state.user.userInfos.hospitalID +
                  '&path=subpackage/consultation/consultation'
                if (isClickNotice == 1) {
                  window.location.href = url
                }
              }
            }
          } else if (type == 'notificationPermissionsChange') {
            // 获取推送权限
            let systemInfo = this.vm.$nativeBridge.sendMessage(
              new NativeMessageData({
                type: 'systemInfo'
              })
            )
            let notification_limit = ''
            if (os.isAndroid()) {
              notification_limit = JSON.parse(systemInfo).notification_limit
            }
            if (os.isIOS()) {
              notification_limit = JSON.parse(JSON.parse(systemInfo).systemInfo).notification_limit
            }
            this.vm.$store.commit('messagePush/setNotificationLimit', notification_limit)
          } else if (type === 'getWechatCode') {
            const { code } = params
            this.vm.$store
              .dispatch('wechat/appGetWXAuthorizeInfo', {
                code
              })
              .then(needBindMobile => {
                if (needBindMobile) {
                  this.vm.$router.push('/bindMobile')
                } else {
                  this.vm.$router.go(-1)
                }
              })
          } else if (type === 'setConsultantChatUnreadMessageNumber') {
            //原生顾问在线未读消息数更新后通知 web 端
            this.vm.$store.commit('messagePush/setUnreadMessages', params)
          } else if (type === 'updateConsultingUnread') {
            // 协同门诊-诊室 im消息通知h5有待回复消息, 把待回复消息会话id存到vuex中方便查询
            this.vm.$store.dispatch('stCommonwealth/asyncSetIMUnreadMessageGroup', params.imGroupId)
          } else if (type === 'updateConsultingDetail') {
            // 协同门诊-诊室 诊室结诊接到通知更新页面状态
            this.vm.$store.commit('stCommonwealth/setConclusionNotice', true)
          }
        }

        return ''
      }
    } catch (e) {
      console.log('函数内错误', e)
    }
  }
}
